import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { SslCertificateCreateRequest, SslCertificateResponse, SslCertificateUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { SslCertificateDetailsSectionHandler } from './details.section';
import { DomSanitizer } from '@angular/platform-browser';

@RegisterEntityHandler('sslcertificate')
@Injectable()
export class SslCertificateHandler extends EntityHandler<SslCertificateResponse> {

    constructor(
        admin: AdminEditorService,
        public sanitizer: DomSanitizer,
    ) {
        super(admin);
    }

    states = ['inactive', 'active', 'deleted'];

    async listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listSslCertificates/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listSslCertificates(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'sslcertificate',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.SSLCERTIFICATE'),
        }));
    }

    getEntity(id: string): Promise<SslCertificateResponse> {
        return this.admin.getCached(`getSslCertificate/${id}`, api => api.entities.getSslCertificate(id), 10);
    }

    async createEntity(ownerId: string, entity: SslCertificateCreateRequest): Promise<SslCertificateResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createSslCertificate(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateSslCertificate(entity.id, { state: state as any }));
    }

    async getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.SSLCERTIFICATE.COLUMNS');
        return [
            grid.IconTextColumn('domain', 'DOMAIN', ICONS.sslcertificate),
            grid.IdNameTextColumn('company', 'COMPANY'),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
    }

    async getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<SslCertificateResponse>[]> {
        return [{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new SslCertificateDetailsSectionHandler(this.admin, ownerId, false),
            ],
        }];
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: SslCertificateUpdateRequest, sections: FormSectionHandler<SslCertificateResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'sslcertificate',
            entity: {}, // set up some defaults if you want
            sections: [
                new SslCertificateDetailsSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












